/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FetchGolabNamesAndDescriptionsResponse } from '../../models/fetch-golab-names-and-descriptions-response';

export interface GolabControllerFetchGolabAppsAndLabsNamesAndDescriptionsInEnglish$Params {
}

export function golabControllerFetchGolabAppsAndLabsNamesAndDescriptionsInEnglish(http: HttpClient, rootUrl: string, params?: GolabControllerFetchGolabAppsAndLabsNamesAndDescriptionsInEnglish$Params, context?: HttpContext): Observable<StrictHttpResponse<FetchGolabNamesAndDescriptionsResponse>> {
  const rb = new RequestBuilder(rootUrl, golabControllerFetchGolabAppsAndLabsNamesAndDescriptionsInEnglish.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FetchGolabNamesAndDescriptionsResponse>;
    })
  );
}

golabControllerFetchGolabAppsAndLabsNamesAndDescriptionsInEnglish.PATH = '/golab/fetch-golab-apps-and-labs-english-name-and-descriptions';
